export const BlockedIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="#787878"
        d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"
      ></path>
      <path
        fill="#787878"
        d="M11.112 4.182l-7 7 .706.708 7-7-.706-.708z"
      ></path>
      <path fill="#787878" d="M4.818 4.111l-.707.707 7 7 .708-.707-7-7z"></path>
    </svg>
  );
};
